// A status tag: Geist Mono, caps, 11px, 20px tall, 6px radius (site-ui.css .pill). The tone is the meaning, never decoration.

import type { HTMLAttributes } from 'react';

export type TagTone = 'neutral' | 'accent' | 'green' | 'amber' | 'red';
const TONE: Record<TagTone, string> = { neutral: '', accent: 'pill-accent', green: 'pill-green', amber: 'pill-amber', red: 'pill-red' };

export function Tag({ tone = 'neutral', className, children, ...rest }: { tone?: TagTone } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={['pill', TONE[tone], className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
